import Vue from 'vue'
import VueI18n from '../i18n.js'
import api from '../connectors/Api'

const $t = VueI18n.t.bind(VueI18n)
const API = api()

export default {
  namespaced: true,
  state: {
    profile: {},
    profileTypeData: {},
    searchSubscription: null
  },
  mutations: {
    setProfile (state, profile) {
      state.profile = profile
    },
    setProfileTypeData (state, data) {
      state.profileTypeData = data
    },
    setSearchSubscription (state, data) {
      state.searchSubscription = data
    }
  },
  getters: {
    hasCompletedTypeData (state) {
      return Object.keys(state.profileTypeData).length > 0 || state.profileTypeData.length > 0
    },
    hasCompletedContractData (state) {
      return state.profile.contract_data && true
    },
    isProfileLoaded (state) {
      return Object.keys(state.profile).length > 0
    },
    getAge: (state) => (birthDate) => {
      const date = birthDate || state.profileTypeData.birth_date
      if (date) {
        const birthDate = new Date(date)
        const otherDate = new Date()

        let years = (otherDate.getFullYear() - birthDate.getFullYear())

        if ((otherDate.getMonth() < birthDate.getMonth() ||
            otherDate.getMonth() === birthDate.getMonth()) && otherDate.getDate() < birthDate.getDate()) {
          years--
        }

        return years
      } else {
        return 0
      }
    },
    emptyAvatar () {
      return `${Vue.$publicPath}img/profile/empty_avatar.jpg`
    },
    getAvatar: (state, getters) => (userData) => {
      if (userData) {
        return userData.avatar ? userData.avatar : getters.emptyAvatar
      } else {
        return state.profile.avatar ? state.profile.avatar : getters.emptyAvatar
      }
    },
    getBackground: (state) => (userData) => {
      const emptyBackground = Vue.$publicPath + 'img/profile/empty_background.jpg'
      if (userData) {
        return userData.background ? userData.background : emptyBackground
      } else {
        return state.profile.background ? state.profile.background : emptyBackground
      }
    },
    hasFreeSearchSubscription (state) {
      return state.searchSubscription ? state.searchSubscription.free : false
    },
    hasActiveSearchSubscription (state) {
      return state.searchSubscription ? state.searchSubscription.active || state.searchSubscription.free : false
    }
  },
  actions: {
    register ({ commit, state }, data) {
      return new Promise((resolve, reject) => {
        data.base_url = window.location.origin + '/register/verify'
        API.registerNewUser(data)
          .then((res) => {
            resolve('ok')
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    registerVerify ({ state }, hash) {
      return new Promise((resolve, reject) => {
        API.verifyRegisterEmail(hash)
          .then((res) => {
            resolve(res.body)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    getProfile ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.userProfile(token)
            .then((res) => {
              commit('setProfile', res.body.user)
              commit('setProfileTypeData', res.body.userData)
              resolve(state.profile)
            })
            .catch((e) => {
              Vue.$flash.error($t('Unable to get data'))
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    editUserEmail ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editUserEmail(token, data)
            .then((res) => {
              commit('setProfile', res.body)
              resolve(state.profile)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    editUserLang ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editUserLang(token, data)
            .then((res) => {
              commit('setProfile', res.body)
              resolve(state.profile)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    editUserNotifications ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editUserNotifications(token, data)
            .then((res) => {
              commit('setProfile', res.body)
              resolve(state.profile)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    editUserTypeData ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editUserTypeData(token, data)
            .then((res) => {
              commit('setProfile', res.body.user)
              commit('setProfileTypeData', res.body.userData)
              resolve(state.profileTypeData)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    editContractData ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editContractData(token, data)
            .then((res) => {
              commit('setProfile', res.body.user)
              resolve(state.profileTypeData)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    editUserPassword ({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.editUserPassword(token, data)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    accountDelete ({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.userAccountDelete(token, data)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    sendPasswordResetLink ({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        data.base_url = window.location.origin + '/password-reset'
        API.sendPasswordResetLink(data)
          .then((res) => {
            resolve(res.body)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    resetPassword ({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        API.resetPassword(data)
          .then((res) => {
            resolve(res.body)
          })
          .catch((e) => {
            reject(e)
          })
      })
    },
    setArchetype ({ commit, state, dispatch }, archetypeId) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.setUserArchetypes(token, archetypeId)
            .then((res) => {
              commit('setProfileTypeData', res.body.userData)
              resolve(res.body.userData)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    getSearchSubscriptionStatus ({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.getSearchSubscriptionStatus(token)
            .then((res) => {
              commit('setSearchSubscription', res.body)
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },

    saveInfluencerPicture ({ commit, state, dispatch }, data) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.addInfluencerPicture(token, data)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    },
    deleteInfluencerPicture ({ commit, state, dispatch }, hash) {
      return new Promise((resolve, reject) => {
        dispatch('auth/getAccessToken', null, { root: true }).then((token) => {
          API.deleteInfluencerPicture(token, hash)
            .then((res) => {
              resolve(res.body)
            })
            .catch((e) => {
              reject(e)
            })
        }).catch((e) => reject(e))
      })
    }
  }
}
